/* eslint-disable no-mixed-operators */
import md5 from "md5";
import { Avatar } from "antd";
import { stringToColor } from "../../lib/utils";
import ImageLoader from "./image-loader";

const UserAvatar = ({ url, email, fullName, isRect = false }) => {
  const shape = isRect ? "square" : "circle";
  const avatarWidth = isRect ? "100px" : "34px";
  const letterSplit = (fullName && fullName.split(" ")) || ["No", "Name"];
  let letters = letterSplit.map((word) => word[0]).join("");
  if (letters.length > 3) {
    letters = letters.slice(0, 3);
  }
  if (!url && email) {
    url = `https://www.gravatar.com/avatar/${md5(email)}?d=robohash`;
  }

  return (
    <div className="__user_avatar_container">
      {!url && (
        <Avatar
          shape={shape}
          style={{
            width: avatarWidth,
            backgroundColor: stringToColor(letters),
            textTransform: "uppercase",
          }}
        >
          {letters}
        </Avatar>
      )}
      {url && <ImageLoader src={url} />}
      <style>{`
        .__user_avatar_container {
          align-items: center;
          border: 1px solid rgba(0,0,0,0.12);
          border-radius: 50%;
          display: flex;
          // height: 38px;
          // width: 38px;
          justify-content: center;
          background-color: #f6f6f6;
        }
        .__user_avatar_container :global(img){
          border-radius: 50%;
          height: 34px;
          width: 34px;
          object-fit: cover;
        }
      `}</style>
    </div>
  );
};

export default UserAvatar;
